import { useTranslation } from 'react-i18next';
import { Loader2, Plus, Send, X } from 'lucide-react';
import Iconify from 'src/components/Iconify';
import { getFileIcon } from './utils/mediaTypes';

// ----------------------------------------------------------------------
// Filmstrip de miniaturas + botão adicionar + botão circular de enviar.

function Thumb({ item }) {
    if (item.kind === 'image') {
        return (
            <img
                src={item.editedUrl || item.originalUrl}
                alt=""
                className="w-full h-full object-cover"
                draggable={false}
            />
        );
    }
    if (item.kind === 'video') {
        return (
            <div className="w-full h-full flex items-center justify-center bg-slate-800">
                <Iconify icon="eva:play-circle-outline" width={22} className="text-white" />
            </div>
        );
    }
    const fileIcon = getFileIcon(item.file);
    return (
        <div className="w-full h-full flex items-center justify-center bg-slate-100 dark:bg-slate-700">
            <Iconify icon={fileIcon.icon} width={24} className={fileIcon.color} />
        </div>
    );
}

export default function MediaFilmstrip({ items, activeId, onSelect, onRemove, onAdd, onSend, sending }) {
    const { t } = useTranslation('chat');

    return (
        <div className="flex items-center gap-3 px-4 py-3">
            <div className="flex-1 flex items-center justify-center gap-2 overflow-x-auto py-1">
                {items.map((item) => (
                    <div
                        key={item.id}
                        role="button"
                        tabIndex={0}
                        onClick={() => onSelect(item.id)}
                        onKeyDown={(event) => event.key === 'Enter' && onSelect(item.id)}
                        className={`group relative w-14 h-14 flex-shrink-0 rounded-lg overflow-hidden cursor-pointer border border-gray-200 dark:border-slate-700 transition-all ${
                            item.id === activeId ? 'ring-2 ring-[#7C3AED]' : 'hover:ring-2 hover:ring-gray-300'
                        }`}
                    >
                        <Thumb item={item} />
                        <button
                            type="button"
                            title={t('mediaEditor.removeFile')}
                            className="absolute top-0.5 right-0.5 hidden group-hover:flex items-center justify-center w-4 h-4 rounded-full bg-black/60 text-white"
                            onClick={(event) => {
                                event.stopPropagation();
                                onRemove(item.id);
                            }}
                        >
                            <X className="w-3 h-3" />
                        </button>
                    </div>
                ))}

                <button
                    type="button"
                    title={t('mediaEditor.addFile')}
                    onClick={onAdd}
                    className="w-14 h-14 flex-shrink-0 rounded-lg border-2 border-dashed border-gray-300 dark:border-slate-600 flex items-center justify-center text-gray-400 hover:text-[#7C3AED] hover:border-[#7C3AED] transition-colors"
                >
                    <Plus className="w-5 h-5" />
                </button>
            </div>

            <div className="relative flex-shrink-0">
                <button
                    type="button"
                    title={t('mediaEditor.send')}
                    disabled={sending}
                    onClick={onSend}
                    className="h-12 w-12 rounded-full bg-[#7C3AED] hover:bg-[#6d28d9] disabled:opacity-60 text-white flex items-center justify-center shadow-lg shadow-[#7C3AED]/30 transition-all active:scale-95"
                >
                    {sending ? <Loader2 className="w-5 h-5 animate-spin" /> : <Send className="w-5 h-5" />}
                </button>
                {items.length > 1 && (
                    <span className="absolute -top-1 -right-1 min-w-[20px] h-5 px-1 rounded-full bg-slate-900 dark:bg-white text-white dark:text-slate-900 text-[11px] font-bold flex items-center justify-center">
                        {items.length}
                    </span>
                )}
            </div>
        </div>
    );
}
